module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/mhip1-4084b50911eab05d7bdca0408e034101.jpg";